import { Route, Routes, useLocation } from 'react-router-dom';
import { lazy, Suspense, useEffect } from 'react';
import Lazy from './layout/Lazy';

export default function App() {
  const Home = lazy(()=> import('./pages/Home2'))
  const NotFound = lazy(()=> import('./components/NotFound'))

  
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change

  return (
    <Suspense fallback={<Lazy/>}>
      <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/404' element={<NotFound/>}/>
          <Route path='*' element={<NotFound/>}/>
      </Routes>
    </Suspense>
  );
}
